import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

export function FeatureCard({
  icon,
  title,
  desc,
}: {
  icon: React.ReactNode;
  title: React.ReactNode;
  desc: React.ReactNode;
}) {
  return (
    <Card className="border-gray-200/70 transition-shadow hover:shadow-sm dark:border-gray-800">
      <CardHeader>
        <CardTitle className="text-base flex items-center gap-4">
          <div className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-orange-600/10 text-orange-700 dark:text-orange-300">
            {icon}
          </div>
          {title}
        </CardTitle>
        <CardDescription className="text-sm leading-relaxed">
          {desc}
        </CardDescription>
      </CardHeader>
    </Card>
  );
}
